import { render, staticRenderFns } from "./NutritionStatusForm.vue?vue&type=template&id=6d02aa35&scoped=true&lang=html&"
import script from "./NutritionStatusForm.vue?vue&type=script&lang=js&"
export * from "./NutritionStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./NutritionStatusForm.vue?vue&type=style&index=0&id=6d02aa35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d02aa35",
  null
  
)

export default component.exports